<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
const { initClickTracking } = await useTracking();
const { otLoadHeader } = useOneTrust();

initClickTracking();

const cspReporter = await useStaticAsset('/global-assets/csp-reporter.js', {
  tag: 'csp-reporter',
});

const scripts = [];

if (cspReporter) {
  scripts.push({
    type: 'text/javascript',
    src: cspReporter.cdnPathname,
    tagPriority: 0,
    id: 'csp-reporter',
  });
}

useHead({
  bodyAttrs: {
    class: 'bg-white',
  },
  script: scripts,
});

otLoadHeader({
  groupKeys: ['F'],
  headConfigs: [
    {
      hid: 'qualified-loader',
      type: 'text/javascript',
      src: 'https://js.qualified.com/qualified.js?token=MNZB19PdEuZXHF1v',
      async: true,
    },
  ],
});
</script>
